<template>
  <div style="padding-right: 30px">
    <el-form ref="form" :model="form" :rules="rules" label-width="140px">
      <el-form-item label="是否开启">
        <el-select v-model="form.isOpen" placeholder="请选择" @change="valueChange">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="托运低分阈值">
        <el-input v-model="form.shipmentLowThreshold" type="number" :disabled="inputDis" @change="value=>setkey(value,'shipmentLowThreshold')" />
      </el-form-item>
      <el-form-item label="承运低分阈值">
        <el-input v-model="form.driverLowThreshold" type="number" :disabled="inputDis" @change="value=>setkey(value,'driverLowThreshold')" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submit">确定</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { updateEvaluationManagementConfig, getEvaluationManagementConfig } from "@/api/CustomerService";
export default {
  name: "TransportAbnormalDetail",
  data() {
    return {
      form: {
        isOpen: '0',
        shipmentLowThreshold: 0,
        driverLowThreshold: 0,
      },
      rules:{
        shipmentLowThreshold: [
          { required: true, message: "请输入托运低分阈值", trigger: "blur" },
          {
            validator(rule, value, callback) {
             value<=100 ? callback() : callback(new Error("托运低分阈值小于100"));
            },
            trigger: "blur"
          }
        ],
        driverLowThreshold: [
          { required: true, message: "请输入承运低分阈值", trigger: "blur" },
           {
            validator(rule, value, callback) {
             value<=100 ? callback() : callback(new Error("承运低分阈值小于100"));
            },
            trigger: "blur"
          }
        ],
      },
      options:[
          {
              label:'关闭',
              value:'0'
          },
          {
              label:'开启',
              value:'1'
          }
      ],
      
      inputDis:true
    };
  },
  created() {

  },
  methods: {
    // 设置货物数量
    setkey(value,key){
      if(value==''){
        this.$set(this.form, key, 0)
      }
      else{
        this.$set(this.form, key, value.replace(/\.[0-9]+/,''))
      }
    },
    valueChange(e){
      if(e==1){
        this.inputDis = false
      }else{
        this.inputDis = true
      }
    },
    async getInfo() {
      this.form = {};
      let response = await getEvaluationManagementConfig()
      this.form = response.data;
      this.inputDis = !this.form.isOpen
    },
    async submit(){
      const rLoading = this.openLoading();
      let response = await updateEvaluationManagementConfig(this.form)
      this.$message.success(response.msg)
      rLoading.close()
      this.$emit('setUped')
    }
  }
};
</script>
